module.exports = __webpack_public_path__ + "static/img/02344_7.86c6378.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/img/02344_7.jpg
// module id = yJPs
// module chunks = 1